import { useLayoutEffect } from "react"

import { BrowserRouter } from "react-router-dom"
import ThemeProvider from "themes/theme-provider"

import AppErrorModal from "components/AppErrorModal"
import { AuthenticationWrapper } from "components/AuthenticationWrapper"
import CIDWrapper from "components/CidWrapper"
import ClientWrapper from "components/ClientWrapper"

import { AuthProvider } from "context/AuthProvider"
import { ClientProvider } from "context/ClientProvider"
import { ErrorProvider } from "context/ErrorProvider"
import { MsalProvider } from "context/MsalProvider"
import { UserProvider } from "context/UserProvider"

import { setupQueryParamsToLocalStorage } from "utilities/helpers"

export const App = () => {
  useLayoutEffect(() => {
    setupQueryParamsToLocalStorage()
  }, [])

  return (
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <ClientProvider>
        <AuthProvider>
          <MsalProvider>
            <ThemeProvider>
              <ErrorProvider>
                <UserProvider>
                  <CIDWrapper>
                    <ClientWrapper>
                      <AuthenticationWrapper />
                      <AppErrorModal />
                    </ClientWrapper>
                  </CIDWrapper>
                </UserProvider>
              </ErrorProvider>
            </ThemeProvider>
          </MsalProvider>
        </AuthProvider>
      </ClientProvider>
    </BrowserRouter>
  )
}
